import React from "react";
import { string } from "prop-types";
import { useTranslation } from "@lib/i18n";
import { useIsB2BSelected } from "@hooks/useIsB2BSelected";

import { Button } from "@components/shared/Button";
import Typography from "../shared/Typography";

const LeadFormButton = ({ link }) => {
  const { t, i18n } = useTranslation();
  const isB2BSelected = useIsB2BSelected();

  const ctaKey =
    isB2BSelected && i18n.exists("footer.leadFormCTAB2B")
      ? "footer.leadFormCTAB2B"
      : "footer.leadFormCTA";
  const buttonKey =
    isB2BSelected && i18n.exists("footer.leadFormButtonB2B")
      ? "footer.leadFormButtonB2B"
      : "footer.leadFormButton";

  return (
    <div className="flex flex-col items-center justify-center gap-4 h-40 p-8">
      <Typography className="text-sm">{t(ctaKey)}</Typography>
      <Button
        onClick={() => window.open(link, "_blank", "noopener,noreferrer")}
        data-id="footer-lead-form-button"
      >
        {t(buttonKey)}
      </Button>
    </div>
  );
};

LeadFormButton.propTypes = {
  link: string.isRequired,
};

export default LeadFormButton;
